module.exports = __webpack_public_path__ + "img/w1-b3.58b9205d.jpg";